/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var BuildingHomeIcon20Regular = forwardRef('BuildingHomeIcon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8.09 3.907a2.7 2.7 0 0 1 3.82 0l6.31 6.31a.75.75 0 1 0 1.06-1.06l-6.31-6.31a4.2 4.2 0 0 0-5.94 0L.72 9.157a.75.75 0 1 0 1.06 1.06l6.31-6.31Z" }),
        React.createElement("path", { d: "M5.5 10A.75.75 0 0 0 4 10v4.75A3.25 3.25 0 0 0 7.25 18h5.5A3.25 3.25 0 0 0 16 14.75V10a.75.75 0 0 0-1.5 0v4.75a1.75 1.75 0 0 1-1.75 1.75h-5.5a1.75 1.75 0 0 1-1.75-1.75V10Z" })));
});
